import { Box, Typography } from '@mui/material';

function TopBar({ eyebrow, title, subtitle, actions }) {
  return (
    <Box
      sx={{
        alignItems: { xs: 'flex-start', lg: 'center' },
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: 2,
        justifyContent: 'space-between',
        mb: 4,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography color="text.secondary" fontWeight={800} letterSpacing="0.14em" variant="overline">
          {eyebrow}
        </Typography>
        <Typography sx={{ mt: 0.5 }} variant="h2">
          {title}
        </Typography>
        {subtitle ? (
          <Typography color="text.secondary" sx={{ maxWidth: 780, mt: 1 }} variant="body1">
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {actions}
    </Box>
  );
}

export default TopBar;
